module.exports = __webpack_public_path__ + "img/la-memorial-coliseum_field.2363d095.jpg";